/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilebillingownhint3Inputs */

const en_profilebillingownhint3 = /** @type {(inputs: Profilebillingownhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applies to this profile only.`)
};

const de_profilebillingownhint3 = /** @type {(inputs: Profilebillingownhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gilt nur für dieses Profil.`)
};

/**
* | output |
* | --- |
* | "Applies to this profile only." |
*
* @param {Profilebillingownhint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilebillingownhint3 = /** @type {((inputs?: Profilebillingownhint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilebillingownhint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilebillingownhint3(inputs)
	return de_profilebillingownhint3(inputs)
});
export { profilebillingownhint3 as "profileBillingOwnHint" }